import React from 'react';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../ui/input-otp';
import { fettTeile } from '../../lib/zweiFaktor';

// Zeigt **fett** aus den Anleitungstexten als <strong>.
export const Fett = ({ text }) => (
  <>
    {fettTeile(text).map(({ teil, fett }, i) => (fett ? <strong key={i}>{teil}</strong> : <React.Fragment key={i}>{teil}</React.Fragment>))}
  </>
);

const nurZiffern = (text) => String(text || '').replace(/\D/g, '').slice(0, 6);

export const CodeFelder = ({ wert, onChange, onComplete, feldRef, disabled = false }) => (
  <InputOTP
    ref={feldRef}
    maxLength={6}
    value={wert}
    onChange={(v) => onChange(nurZiffern(v))}
    onComplete={(v) => onComplete && onComplete(nurZiffern(v))}
    pasteTransformer={nurZiffern}
    autoComplete="one-time-code"
    inputMode="numeric"
    pattern="^[0-9]*$"
    autoFocus
    disabled={disabled}
    aria-label="6-stelliger Code"
    containerClassName="justify-center"
    data-testid="zwei-faktor-code-felder"
  >
    <InputOTPGroup>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <InputOTPSlot key={i} index={i} className="h-11 w-11 text-base" />
      ))}
    </InputOTPGroup>
  </InputOTP>
);

export default CodeFelder;
